import { Upload } from "antd";
import { useEffect, useState } from "react";
import { showToast } from "ui/components/common";
import { SvgImageUpload, SvgMusicDisabled } from "ui/svgs";
import { LoadingOutlined } from "@ant-design/icons";
import { uploadSign } from "pages/service";

export default function ImageUpload({
  onChange,
  value,
  className,
  uploadingControl = false,
}: {
  onChange?: ({ key, url }) => void;
  value: any;
  className?: string;
  uploadingControl?: boolean; // control the uploading status
}) {
  console.log("ImageUpload value", value);
  const [uploading, setUploading] = useState(false);
  const [key, setKey] = useState("");
  const [imgURL, setImgURL] = useState(value?.url); // just show the image in the UI

  useEffect(() => {
    setImgURL(value?.url);
  }, [value]);

  useEffect(() => {
    setUploading(uploadingControl);
  }, [uploadingControl]);
  return (
    <div className={className}>
      <Upload.Dragger
        accept=".png,.jpg,.jpeg"
        headers={{ "Content-Type": "image/jpeg" }}
        name="file"
        method={"put"}
        disabled={uploading || imgURL}
        className="max-h-full max-w-full"
        beforeUpload={async (file) => {
          if (file.size > 1024 * 1024 * 2) {
            showToast(1, "File size should be less than 2MB");
            setUploading(false);
            return false;
          }
          return true;
        }}
        action={async (file) => {
          const res = await uploadSign(file.name);
          if (res.status !== 200) {
            showToast(1, "Failed to get upload signaure");
            setUploading(false);
            return "";
          } else {
            setKey(res.data.key);
            setImgURL(res.data.downloadSignUrl);
            return res.data.uploadSignUrl;
          }
        }}
        customRequest={async (props) => {
          if (!props.action) return;
          try {
            await fetch(props.action, {
              method: "PUT",
              body: props.file,
              headers: {
                "Content-Type": "image/jpeg",
              },
            });
            const reader = new FileReader();
            reader.onload = (e) => {
              setImgURL(e.target.result);
            };
            reader.readAsDataURL(props.file as Blob); // 将文件读取为 Data URL
            props.onSuccess(key);
          } catch (e) {
            setUploading(false);
            console.error(e);
            props.onError(e);
          }
        }}
        multiple={false}
        maxCount={1}
        showUploadList={false}
        onChange={(info) => {
          const { status } = info.file;
          if (status === "uploading") {
            setUploading(true);
          }
          if (status === "done" && uploading) {
            setUploading(false);
            showToast(0, "Upload Success");
            onChange?.({ key, url: imgURL });
          }
          if (status === "error" && uploading) {
            setUploading(false);
            showToast(1, "Upload Failed");
          }
        }}
      >
        <>
          {uploading && (
            <div className="mask">
              <LoadingOutlined style={{ marginRight: "12px" }} />
              Uploading...
            </div>
          )}
          {imgURL ? (
            <div className="bg-black w-full h-full flex justify-center items-center rounded-lg max-h-full max-w-full ">
              <img
                src={imgURL}
                className="max-w-full max-h-full object-contain "
              />
            </div>
          ) : (
            <div className="flex items-center flex-col justify-center h-full">
              <SvgImageUpload />
              <div className="mt-2">
                Drag and Drop Image Here or{" "}
                <span
                  style={{ fontWeight: "600", cursor: "pointer" }}
                  className="underline"
                >
                  Choose a File
                </span>
              </div>
            </div>
          )}
        </>
      </Upload.Dragger>
    </div>
  );
}
